import { TLocoType } from 'shared/hooks/use-loco-translation'

export const defaultValues = (t: TLocoType) => {
  return {
    name: '',
    stages: [
      {
        name: t('dashboard.crm_pipeline.create_modal.first_default_value'),
        position: 1,
      },
      {
        name: t('dashboard.crm_pipeline.create_modal.second_default_value'),
        position: 2,
      },
      {
        name: t('dashboard.crm_pipeline.create_modal.third_default_value'),
        position: 3,
      },
      {
        name: t('dashboard.crm_pipeline.create_modal.fourth_default_value'),
        position: 4,
      },
      {
        name: t('dashboard.crm_pipeline.create_modal.fifth_default_value'),
        position: 5,
      },
      {
        name: t('dashboard.crm_pipeline.create_modal.sixth_default_value'),
        position: 6,
      },
    ],
  }
}
